"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackIcon = void 0;
var react_1 = __importDefault(require("react"));
var BackIcon = function () {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
        react_1.default.createElement("path", { d: "M9.6875 15L4.0625 9.375L9.6875 3.75M4.84375 9.375H16.25", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.BackIcon = BackIcon;
